export default __webpack_public_path__ + "static/cafe_36021-22e285fcfdc8266406083de446646a50.png";